import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import { Link } from "@quintype/components";
import { dateFormatterWithoutTime } from "../../../utils";
import TimeAgo from "react-timeago";
import "./author.m.css";

export const Author = ({ story }) => {
  const { name: authorName, slug, id } = get(story, ["authors", "0"], "");
  return (
    <div styleName="authorWithTimeStamp" className="authorWithTimeStamp">
      <span styleName="authored">By</span>
      {
        <Link href={`/author/${slug}`}>
          <span styleName="author-name">
            {authorName || story["author-name"]}
          </span>
        </Link>
      }
      <TimeAgo
        styleName="time-ago"
        formatter={dateFormatterWithoutTime}
        date={story["last-published-at"]}
        live={false}
      />
    </div>
  );
};

export const Authors = ({ story }) => {
  const getAuthors = get(story, ["authors"], []);
  return (
    <div styleName="authorWithTimeStamp" className="authorWithTimeStamp">
      <span styleName="authored">By</span>
      {getAuthors.slice(0, 3).map((item, index) => {
        return (
          <Link href={`/author/${item.slug}`} key={index}>
            <span styleName="author-name">
              {(index ? "& " : "") + item.name.trim()}
            </span>
          </Link>
        );
      })}
      <TimeAgo
        styleName="time-ago"
        date={story["last-published-at"]}
        formatter={dateFormatterWithoutTime}
        live={false}
      />
    </div>
  );
};

Author.propTypes = {
  story: PropTypes.object.isRequired
};
